module.exports = __webpack_public_path__ + "static/media/29EUNOG3.2a8d5326.jpg";